/**
 * Footer section behavior (matches live malbon.com footer):
 * - Exclusive menu accordions: opening one <details> closes the others
 *   at the same nesting level (live custom.js behavior).
 * - EU-only links: reveals links flagged in the section for EU visitors,
 *   based on window.Shopify.country (live eu-only-wb snippet behavior).
 * - Language selector: submits the localization form on change.
 */
if (!customElements.get('footer-section')) {
  const EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  ];

  customElements.define(
    'footer-section',
    class FooterSection extends HTMLElement {
      constructor() {
        super();
        this.onAccordionToggle = this.onAccordionToggle.bind(this);
        this.onLocaleChange = this.onLocaleChange.bind(this);
      }

      connectedCallback() {
        this.setupAccordions();
        this.setupLocaleSelector();
        this.revealEuOnlyLinks();
      }

      disconnectedCallback() {
        for (const accordion of this.querySelectorAll('details[data-footer-accordion]')) {
          accordion.removeEventListener('toggle', this.onAccordionToggle);
        }

        const select = this.querySelector('[data-footer-locale]');
        select?.removeEventListener('change', this.onLocaleChange);
      }

      setupAccordions() {
        for (const accordion of this.querySelectorAll('details[data-footer-accordion]')) {
          accordion.addEventListener('toggle', this.onAccordionToggle);
        }
      }

      /**
       * Closes every other open accordion at the same nesting level.
       * @param {Event} e - The toggle event from a <details> element
       */
      onAccordionToggle(e) {
        const opened = e.target;
        if (!opened.open) return;

        const level = opened.dataset.footerAccordion;
        for (const accordion of this.querySelectorAll(`details[data-footer-accordion="${level}"]`)) {
          if (accordion !== opened) accordion.open = false;
        }
      }

      setupLocaleSelector() {
        const select = this.querySelector('[data-footer-locale]');
        select?.addEventListener('change', this.onLocaleChange);
      }

      onLocaleChange(e) {
        e.target.form?.submit();
      }

      revealEuOnlyLinks() {
        if (!this.querySelector('.footer__menu-item--eu-only')) return;

        const country = window.Shopify?.country;
        if (country && EU_COUNTRIES.includes(country)) {
          this.classList.add('footer--eu');
        }
      }
    }
  );
}
